<template>
  <div class="roadWrap">
    <Car
      class="car"
      :oldPosition="this.oldPosition"
      :newPosition="this.newPosition"
      :currentPosition="this.currentPosition"
      :calcTiming="this.calcTiming"
      :linear="this.linear"
      @changePosition="this.getPosition"
    />

    <Road
      :oldPosition="this.oldPosition"
      :newPosition="this.newPosition"
      :calcTiming="this.calcTiming"
      :linear="this.linear"
    />

    <CheckPoint
      v-for="checkpoint in this.checkpoints"
      :class="checkpoint.class"
      :index="checkpoint.index"
      :currentPosition="currentPosition"
      :oldPosition="oldPosition"
      :position="checkpoint.position"
      :visibleFlag="visibleFlag"
      :toggleFlag="toggleFlag"
      color="#000000"
    >
      <template #text>
        <p>{{ checkpoint.text }}</p>
      </template>
      <component :text="checkpoint.props" :is="checkpoint.element" />
    </CheckPoint>

    <CheckPoint
      class="point5"
      :index="5"
      :currentPosition="currentPosition"
      :oldPosition="oldPosition"
      :position="100"
      :visibleFlag="visibleFlag"
      :toggleFlag="toggleFlag"
      :isFinish="true"
    >
      <template #banner>
        <FinishBanner />
      </template>

      <FinishFlag />
    </CheckPoint>
  </div>
</template>

<script>
//
import Car from "./Car.vue";
import Road from "./Road.vue";
import CheckPoint from "./CheckPoint.vue";
import StartFlag from "./StartFlag.vue";
import FinishFlag from "./FinishFlag.vue";
import FlagText from "./FlagText.vue";

import FinishBanner from "./FinishBanner.vue";

export default {
  components: {
    Car,
    CheckPoint,
    StartFlag,
    FinishFlag,
    Road,
    FlagText,
    FinishBanner,
  },

  props: {
    newBalance: Number,
  },

  data() {
    return {
      visibleFlag: 0,
      currentPosition: 0,
      checkpoints: [
        {
          class: "point1",
          index: 1,
          element: StartFlag,
          props: "",
          position: 0,
          text:
            "Приветствуем в нашей программе мотивации! Загружай чеки с продаж, выполняй задания и получай баллы. Свой путь можно отслеживать, наблюдая за перемещением гоночной машины. Чем больше баллов ты заработал, тем больше шансов поучаствовать в розыгрышах. Лучшие из лучших получат возможность добраться до финала и отправиться с нами на завод производителя! Желаем удачи и отличных продаж!",
        },
        {
          class: "point2",
          index: 2,
          element: FlagText,
          props: "1000",
          position: 0.18,
          text:
            'Поздравляем! Ты получаешь шанс участвовать в розыгрыше 1000 баллов. Все розыгрыши будут проводиться после завершения программы (подробности см. в разделах "О программе" и "Новости")',
        },
        {
          class: "point3",
          index: 3,
          element: FlagText,
          props: "2500",
          position: 0.45,
          text:
            'Наши поздравления! Теперь ты участвуешь в розыгрыше классных брендированных подарков (подробности см. в разделе "О программе" и "Новости"). Не останавливайся на полпути, ведь дальше следующая отправная точка!',
        },
        {
          class: "point4",
          index: 4,
          element: FlagText,
          props: "5000",
          position: 0.9,
          text:
            'Наши поздравления! Теперь ты участвуешь в розыгрыше классных брендированных подарков (подробности см. в разделе "О программе" и "Новости"). Не останавливайся на полпути, ведь дальше следующая отправная точка!',
        },
      ],
    };
  },
  methods: {
    toggleFlag(index) {
      index === this.visibleFlag
        ? (this.visibleFlag = 0)
        : (this.visibleFlag = index);
    },

    getPosition(position) {
      this.currentPosition = Number(position.toFixed(2));
    },

    // Для анимаций
    calcTiming(timing) {
      return (timeFraction) => 1 - timing(1 - timeFraction);
    },

    linear(timeFraction) {
      return timeFraction;
    },
  },
  computed: {
    oldPosition: function() {
      let old = Number(localStorage.getItem("position"));

      if (old < this.newPosition) {
        return old;
      } else {
        localStorage.setItem("position", this.newPosition);
        return this.newPosition;
      }
    },
    newPosition: function() {
      return Number((this.newBalance / 5555).toFixed(2));
    },
  },
  watch: {
    currentPosition(newValue) {
      localStorage.setItem("position", this.newPosition);
    },
  },
  mounted() {
    if (this.oldPosition === 0) {
      this.visibleFlag = 1;
    }
  },
};
</script>

<style scoped>
.roadWrap {
  position: absolute;
  height: 624px;
  left: 70px;
  bottom: 0;
  width: 1214px;
  overflow-y: hidden;
}

@media (max-width: 1700px) {
  .roadWrap {
    width: calc(100% - 70px);
  }
}

@media (max-width: 1400px) {
  .roadWrap {
    left: 0;
    overflow-x: scroll;
  }
}

@media (max-width: 800px) {
  .roadWrap {
    bottom: 90px;
    width: 100%;
  }
}

.car {
  position: absolute;
  top: 0;
  left: 0;
}

.road {
  position: absolute;
  top: 0;
  left: 0;
}

.point1 {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 100px;
  margin-bottom: 58px;
}

.point2 {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 350px;
  margin-bottom: 78px;
}

.point3 {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 580px;
  margin-bottom: 178px;
}

.point4 {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 840px;
  margin-bottom: 204px;
}

.point5 {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: 1040px;
  margin-bottom: 358px;
}
</style>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/RoadAndCar.vue